<script lang="ts">
  import axios from "axios";
  import { createEventDispatcher } from "svelte";
  import { t } from "../../../../core";
  import { loginForQuestionaire } from "../../../../shared/services/questionaire";
  import type { QuestionnaireBlockType } from "../../../layouts/header/user/user-store";

  const dispatch = createEventDispatcher();

  export let questionnaire: QuestionnaireBlockType;

  $: questionnairesCountText = t("Popup.Questionnaire.Teaser")
    .replace("{currentNumber}", `${questionnaire.status}`)
    .replace("{totalCount}", `${2}`);

  function onLinkClick() {
    Promise.all([loginForQuestionaire(questionnaire), axios.post("/api/Questionnaire/blockChecked")]).then(
      (res) => {
        dispatch("close");
      }
    );
  }
</script>

<div class="popup">
  <div class="popup-top">
    <h3 class="popup-top__title">{t("Popup.Questionnaire.Title")}</h3>
    <button class="popup-top__close" on:click={() => dispatch("close")}>
      <svg width="20" height="20">
        <use xlink:href="#close" />
      </svg>
    </button>
  </div>
  <p class="popup__teaser">{questionnairesCountText}</p>
  <div class="popup__description">
    {t("Popup.Questionnaire.Description")}
  </div>
  <a
    href={questionnaire.statusUrl}
    class="btn"
    target="_blank"
    on:click|preventDefault={onLinkClick}
  >
    {t("Popup.Questionnaire.Link")}
  </a>
</div>

<style lang="scss">
  .popup {
    background-color: $background-color;
    font-size: 16px;
    line-height: 1.2;
    width: 600px;
    max-width: 100%;
    padding: 40px 40px 50px;
    margin: auto;

    &-top {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      min-height: 40px;
      position: relative;
      margin-bottom: 30px;

      &__title {
        @include h2;
        padding-left: 50px;

        &::before {
          content: "";
          display: block;
          width: 40px;
          height: 40px;
          background-image: url("/images/speed.svg");
          background-size: cover;
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      &__close {
        width: 20px;
        height: 20px;
        margin-left: 10px;
      }
    }

    &__teaser {
      font-weight: bold;
      margin-bottom: 20px;
    }

    &__description {
      margin-bottom: 30px;
    }
  }
</style>
